module.exports = __webpack_public_path__ + "img/invite_award_info1.d1a49acd.png";